import { render, staticRenderFns } from "./UserReset.vue?vue&type=template&id=8fa6b036&"
import script from "./UserReset.vue?vue&type=script&lang=js&"
export * from "./UserReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports